export const PLATFORM_ENTITY = 'Authentic';
